import {
  ControlledDatePicker
} from '@@viewCommonComponents/controlled';
import { isRequiredInput } from '@@viewHelpers/validations';

const SouscriptionCustomerGranteesExtraCompanyInformation = ({ form }) => {
  return (

    <ControlledDatePicker
      name="company.creationDate"
      label="Date de création de l’entreprise"
      data-testid="ADHERENT_COMPANY_CREATION_DATE"
      rules={isRequiredInput(true)}
      form={form}
      disabled={true}
    />

  );
};

export default SouscriptionCustomerGranteesExtraCompanyInformation;
